import React, { useState, useEffect, useContext } from 'react';
import styles from './styles.module.scss';
import Select from 'react-select';
import NeedStateStore from 'src/stores/NeedStateStore';
import { observer } from 'mobx-react';
import * as utils from 'src/utils';
import useIsOptionsLoading from 'src/utils/hooks/useIsOptionsLoading';

export interface NeedStateDropDownProps {
    onChange: Function;
    selected?: number;
    allowEmpty?: boolean;
    selectedValue?: string | number;
    isMulti?: boolean;
    defaultValue?: any;
    placeholder?: string;
}

function NeedStateDropDown(props: NeedStateDropDownProps) {
    const needStateStore = useContext(NeedStateStore);
    const [selected, setSelected] = useState(null);

    const options = needStateStore.needStatesDropdownValues;
    const isLoading = useIsOptionsLoading(options);

    useEffect(() => {
        needStateStore.getNeedStates();
    }, []);
    useEffect(() => {
        const selectedVal = options.find((i) => i.value === props.selectedValue);
        if (selectedVal) {
            setSelected(selectedVal);
        }
    }, [props.selectedValue, options]);

    useEffect(() => {
        if (!props.defaultValue) return;
        let selectedVal;
        selectedVal = options.find((i) => i.value === props.defaultValue);
        if (selectedVal) {
            if (props.isMulti && !utils.isArray(selectedVal)) {
                selectedVal = [selectedVal];
            }
            setSelected(selectedVal);
            props.onChange(selectedVal);
        }
    }, [props.defaultValue, options]);

    return (
        <Select
            value={props.selected ? props.selected : selected}
            onChange={(s: any) => {
                setSelected(s);
                props.onChange(s || (props.isMulti ? [] : null));
            }}
            isLoading={isLoading}
            isClearable={props.allowEmpty}
            className={styles.select}
            options={options}
            placeholder={props.placeholder ? props.placeholder : 'Select Status'}
            onMenuOpen={() => {
                // Make sure it refetches facilities when the menu is opened in case there was an initial load issue
                needStateStore.getNeedStates();
            }}
            isMulti={props.isMulti}
            styles={utils.styleSelectComponent()}
        />
    );
}

export default observer(NeedStateDropDown);
